<template>
  <div
    v-if="event.assignedPeopleCollection?.length"
    class="group/assigned-people -m-1 flex flex-row rounded-full border bg-white p-1 dark:bg-slate-700"
    :draggable="editable"
    @dragstart="handleDragStart"
    @dragend="handleDragEnd"
  >
    <div class="flex gap-2">
      <div v-if="editable" class="flex shrink-0 empty:hidden">
        <AssignedUsersPopover
          v-if="event.assignedPeopleCollection?.length > 1"
          :event-id="event.id"
          :assigned-people="event.assignedPeopleIds"
          :size="size"
          @event-updated="(event) => (localEvent = event)"
          @fetch-events="$emit('fetch-events')"
        />
      </div>
      <div class="flex flex-1">
        <template
          v-for="assignedPerson in event.assignedPeopleCollection"
          :key="assignedPerson.id"
        >
          <AssignedPerson
            v-if="!assignedPerson.disponibility?.events_material_resources_id"
            :assigned-person="assignedPerson"
            :event-id="event.id"
            :editable="editable"
            :size="size"
            @event-updated="(event) => (localEvent = event)"
            @fetch-events="$emit('fetch-events')"
          />
        </template>
      </div>
    </div>
    <div
      v-if="editable"
      class="flex w-0 shrink-0 cursor-grab items-center justify-center overflow-hidden text-slate-400 transition-all group-hover/assigned-people:text-slate-900 group-hover/event-card:w-6 group-hover/event-card:p-1"
    >
      <FontAwesomeIcon :icon="['far', 'grip-vertical']" fixed-width />
    </div>
  </div>
</template>

<script>
import AssignedPerson from '@c/Dashboard/Content/Planning/components/AssignedPerson.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapActions } from 'vuex'
import AssignedUsersPopover from '@c/Dashboard/Content/Planning/components/AssignedUsersPopover.vue'

export default {
  name: 'AssignedPeopleList',
  components: { AssignedUsersPopover, FontAwesomeIcon, AssignedPerson },
  props: {
    event: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validator: (value) =>
        ['extra-small', 'small', 'medium', 'large', 'extra-large'].indexOf(
          value
        ) !== -1
    }
  },
  emits: ['update:event', 'fetch-events'],
  computed: {
    localEvent: {
      get() {
        return this.event
      },
      set(value) {
        this.$emit('update:event', value)
      }
    }
  },
  methods: {
    ...mapActions({
      processSetDataTransferObjectAction: 'planning/setDataTransferObject'
    }),
    handleDragStart(event) {
      this.processSetDataTransferObjectAction({
        type: 'user-list',
        event: this.event.id
      })
    },
    handleDragEnd(event) {
      this.processSetDataTransferObjectAction({})
    }
  }
}
</script>
